import { createSlice } from '@reduxjs/toolkit';
import { getParameterMethodStates } from 'ducks/parameter-methods-list/operators';
import { Slices } from 'ducks/slices';
import { normalizeLookups } from 'ducks/utils';

export type ParameterMethodsListState = ReturnType<
  typeof normalizeLookups<'parameter_method_name', 'parameter_method_id'>
>;
const initialState: ParameterMethodsListState = [];

const parameterMethodsListSlice = createSlice({
  name: Slices.PARAMETER_METHODS_LIST,
  initialState,
  reducers: {
    clearParameterMethodsList: () => {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getParameterMethodStates.pending, () => {
        return initialState;
      })
      .addCase(getParameterMethodStates.fulfilled, (_, { payload }) => {
        return normalizeLookups(payload, 'parameter_method_name', 'parameter_method_id');
      })
      .addCase(getParameterMethodStates.rejected, () => {
        return initialState;
      });
  },
});

export const { clearParameterMethodsList } = parameterMethodsListSlice.actions;

export default parameterMethodsListSlice.reducer;
